module.exports = __webpack_public_path__ + "img/installation-3.1159a9c1.png";